import { api } from '@/utils/api';

export const useStepsCreateMutation = () => {
  const utils = api.useUtils();

  return api.steps.create.useMutation({
    onSuccess: async (res) => {
      const pendingStepsCount = res.pendingStepsCount;
      _applyCountPendingOneOffStepsUpdate(utils, pendingStepsCount);

      await Promise.all([
        utils.steps.forContact.invalidate(),
        utils.steps.allNextExecutable.invalidate(),
        // utils.steps.nextStep.invalidate(),
        utils.steps.paginated.invalidate(),
        utils.contact.byId.invalidate(),
        utils.team.id.invalidate(),

        utils.steps.universalNextOne.invalidate({ teamId: res.teamId }),
      ]);
    },
  });
};

export const useStepsDeleteBulkMutation = () => {
  const utils = api.useUtils();
  return api.steps.deleteBulk.useMutation({
    onSuccess: async (res) => {
      const pendingStepsCount = res.pendingStepsCount;
      _applyCountPendingOneOffStepsUpdate(utils, pendingStepsCount);

      await Promise.all([
        utils.steps.forContact.invalidate(),
        utils.steps.allNextExecutable.invalidate(),

        utils.steps.paginated.invalidate(),
        utils.team.id.invalidate(),
        utils.steps.universalNextOne.invalidate(),
        utils.steps.universalNextOne.invalidate({ teamId: res.teamId }),
      ]);
    },
  });
};

function _applyCountPendingOneOffStepsUpdate(utils: ReturnType<typeof api.useUtils>, newCount?: number | null) {
  if (newCount == null) return;

  // update pendingOneOffStepsCount on user if user exists
  utils.user.me.setData(undefined, (data) => {
    if (data == null || data.userTeam == null) return data;
    return {
      ...data,
      userTeam: {
        ...data.userTeam,
        pendingOneOffStepsCount: newCount,
      },
    };
  });
}
